module.exports = __webpack_public_path__ + "img/mt.28a38847.png";